import { useEffect, useState } from 'react';
import { fetchComplaintExample } from '../api/settings';

/**
 * 投诉表单「示范」文字（2026-09-23）。手机端 `Submit.tsx` 与 PC 端 `PcForm.tsx` 共用。
 *
 * 返回 `null` ＝ 还在取（最多 4 秒，超时即回落默认文案）。调用方此时**不渲染**示范块，
 * 而不是先摆默认文案再换 —— 协会改过示范时，先闪一下旧示范再跳成新的，
 * 市民可能正读到一半；晚半秒出现比「读着读着字变了」好。
 */
export function useComplaintExample(): string | null {
  const [text, setText] = useState<string | null>(null);
  useEffect(() => {
    let alive = true;
    void fetchComplaintExample().then((t) => {
      if (alive) setText(t);
    });
    return () => {
      alive = false;
    };
  }, []);
  return text;
}
